import { useQuery } from 'react-query';

import getPromotionBlock from '@/common/api/promotion-block/getPromotionBlock';
import { ENDPOINT_PROMOTION_BLOCK_LIST } from '@/common/constants';

const usePromotionBlock = ({ type, position, page, limit }) =>
  useQuery(
    [ENDPOINT_PROMOTION_BLOCK_LIST, type, position, page, limit],
    getPromotionBlock,
  );

export default usePromotionBlock;
